<template lang="html">
  <div class="wrap">
    <div class="content" id="play">
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import qs from 'qs';
  import moment from 'moment';
  // import * as rrweb from "rrweb";
  import rrwebPlayer from 'rrweb-player';
  import 'rrweb-player/dist/style.css';
  export default {
    mounted() {
      // 初始化数据
      this.fetchFrame(this.$route.params.recordKey);
    },
    methods: {
      moment,
      compare(property) {
         return function(obj1,obj2){
             var value1 = obj1[property];
             var value2 = obj2[property];
             return value1 - value2;     // 升序
         }
      },
      getCDNJson(url) {
        return axios.get(url).then(response => {
          return response;
        });
      },
     async fetchFrame(recordKey) {
        const query = {
          recordKey: recordKey
        }
        let events = []
        await axios.get(`/behavior/queryTracks?${qs.stringify(query)}`).then(response => {
          events = response.data.data;
        });
        // 获取cdn的URL
        const url = [];
        events && events.map((item, index) => {
          if(item.isCDN) {
            url.push(events[index].track);
          }
        })
        console.log('url内容', url);
        if(url.length > 0) {
          Promise.all(
            url.map(item => {
              return this.getCDNJson(item);
            })
          ).then(res => {
            // 通过url请求获取cdn上的json数据
            let cdnData = res && res.map(item => {
              return item.data
            });
            console.log('通过url请求获取cdn上的json数据', cdnData);
            // 数据结构和排序
            let sortData = cdnData.flat();
            sortData.sort(this.compare("track_id"));
            // 最后播放的数据
            let lastEvent = sortData && sortData.map(item => {
              return item.track;
            })
            console.log('最后播放的数据', lastEvent);
            new rrwebPlayer({
              target: document.getElementById('play'), // 可以自定义 DOM 元素
              data: {
                events: lastEvent,
                width: document.body.clientWidth - 100,
                height: document.body.clientHeight - 200,
              },
            });
          });
        }
      }
    },
    data() {
      return {
        responseData: []
      };
    }
  };
</script>
<style lang="css" scoped>
.wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
